import type { ReactElement } from 'react';

import './ThumbnailList.scss';
import type { EventPhoto } from '../../../../types';
import type { To } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type ThumbnailListProps = {
  photos: EventPhoto[];
  relativeRoutePrefix?: string;
  preserveQueryParams?: boolean;
};

const ThumbnailList = ({
  photos,
  relativeRoutePrefix,
  preserveQueryParams = true,
}: ThumbnailListProps): ReactElement => {
  const { search } = useLocation();
  const to: To = {};
  const { t } = useTranslation();

  if (preserveQueryParams) {
    to.search = search;
  }
  return (
    <ul className={'thumbnails-list'}>
      {photos &&
        photos.map((photo: EventPhoto) => (
          <li className={'thumbnail'} key={photo.id}>
            <Link
              to={{
                ...to,
                pathname: relativeRoutePrefix ? `./${relativeRoutePrefix}/photos/${photo.id}` : `./photos/${photo.id}`,
              }}
              relative={'path'}>
              <img alt={`${t('photos_ui.view_photo')}`} className={'thumbnail__image'} src={photo.thumbnailFile.uri} />
            </Link>
          </li>
        ))}
    </ul>
  );
};

export default ThumbnailList;
